var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PROCENTER_DEFAULT_PLATFORM, PROCENTER_PLATFORM_TABS, } from './procenterTypes';
var PLATFORM_ROUTES = new Set(['computer', 'mobile', 'web']);
export function isAllCategory(alias) {
    var normalized = (alias || '').trim().toLowerCase();
    return normalized === '' || normalized === 'all';
}
export function getPlatformTabs() {
    return PROCENTER_PLATFORM_TABS;
}
/** 解析 /productcenter、/productcenter/{segment}、/productcenter/{category}/{platform} */
export function parseProcenterRoute(pathname) {
    if (pathname === void 0) { pathname = window.location.pathname; }
    var parts = pathname.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean);
    var pageParam = new URLSearchParams(window.location.search).get('page');
    var page = Math.max(1, parseInt(pageParam || '1', 10) || 1);
    if (parts[0] !== 'productcenter') {
        return {
            categoryAlias: '',
            platformRoute: PROCENTER_DEFAULT_PLATFORM,
            page: page,
        };
    }
    var seg1 = (parts[1] || '').toLowerCase();
    var seg2 = (parts[2] || '').toLowerCase();
    if (!seg1) {
        return { categoryAlias: '', platformRoute: PROCENTER_DEFAULT_PLATFORM, page: page };
    }
    if (seg2 && PLATFORM_ROUTES.has(seg2)) {
        return { categoryAlias: seg1, platformRoute: seg2, page: page };
    }
    if (PLATFORM_ROUTES.has(seg1)) {
        return { categoryAlias: '', platformRoute: seg1, page: page };
    }
    return { categoryAlias: seg1, platformRoute: PROCENTER_DEFAULT_PLATFORM, page: page };
}
export function buildProcenterApiPath(state) {
    var category = (state.categoryAlias || '').trim();
    var platform = (state.platformRoute || PROCENTER_DEFAULT_PLATFORM).trim();
    if (isAllCategory(category)) {
        return platform ? "/productcenterApi/".concat(encodeURIComponent(platform)) : '/productcenterApi';
    }
    var encodedCategory = encodeURIComponent(category);
    return platform
        ? "/productcenterApi/".concat(encodedCategory, "/").concat(encodeURIComponent(platform))
        : "/productcenterApi/".concat(encodedCategory);
}
export function buildProcenterPagePath(state, page) {
    if (page === void 0) { page = state.page; }
    var category = (state.categoryAlias || '').trim();
    var platform = (state.platformRoute || PROCENTER_DEFAULT_PLATFORM).trim();
    var path = '/productcenter';
    if (isAllCategory(category)) {
        if (platform && platform !== PROCENTER_DEFAULT_PLATFORM) {
            path += "/".concat(encodeURIComponent(platform));
        }
    }
    else if (platform) {
        path += "/".concat(encodeURIComponent(category), "/").concat(encodeURIComponent(platform));
    }
    else {
        path += "/".concat(encodeURIComponent(category));
    }
    if (page > 1) {
        path += "?page=".concat(page);
    }
    return path;
}
export function buildPlatformTabHref(state, platformRoute) {
    return buildProcenterPagePath(__assign(__assign({}, state), { platformRoute: platformRoute, page: 1 }), 1);
}
